import { requestWithAuth } from "./http";

const API_BASE = "https://api.touchprop.com/api/v1/competitions";
const FALLBACK_MESSAGE = "\u062e\u0637\u0627 \u062f\u0631 \u0627\u0631\u062a\u0628\u0627\u0637 \u0628\u0627 \u0633\u0631\u0648\u0631";

const request = (path, options = {}) =>
  requestWithAuth(`${API_BASE}${path}`, options, { fallbackMessage: FALLBACK_MESSAGE });

export function getCompetitionTypes() {
  return request("/list-types/", { method: "GET", cache: "no-store" });
}

export function getTop10Entries(competitionId) {
  return request(`/top10/${competitionId}/`, { method: "GET", cache: "no-store" });
}

export function getMyRank(competitionId) {
  return request(`/my-rank/${competitionId}/`, { method: "GET", cache: "no-store" });
}

export function getAccountCompetitionRanks(accountNumber) {
  return request(`/account-ranks/${encodeURIComponent(accountNumber)}/`, { method: "GET", cache: "no-store" });
}
